import { ChangelogTemplateComponentFilterInput } from '../../../../../../../../../basehub-types'

export const highlightedChangelogFilterFragment: ChangelogTemplateComponentFilterInput =
  {
    highlight: {
      asFloatingBanner: {
        _sys_id: { startsWith: '' },
      },
      asNewTab: {
        value: true,
      },
    },
  }
